import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const mainContentStyle = makeStyles((theme: Theme) =>
  createStyles({
    mainTab: {
      borderBottom: "1px solid " + theme.customColors.cntntCntnr,
      "& .MuiTabs-indicator": {
        backgroundColor: theme.customColors.button + "!important",
      },
    },
    tab: {
      minWidth: "50% !important",
      color: theme.customColors.button + " !important",
    },
    tabbedPanel: {
      padding: "20px !important",
      paddingRight: "0 !important",
      paddingLeft: "0 !important",
      margin: "0 !important",
      "& .MuiBox-root": {
        paddingTop: "0 !important",
      },
    },
    owner: {
      maxHeight: "120px",
      maxWidth: "100%",
      width: "100%",
      // paddingRight: '5px',
    },
    mainHeader: {
      width: "100%",
      color: theme.customColors.childBack,
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: 600,
      height: "fit-content",
    },
    sellHeader: {
      color: theme.customColors.dark,
      fontSize: window.innerWidth > 1300 ? "36px" : "30px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "40px",
      width: "auto",
    },
    mainSlsCircle: {
      backgroundColor: theme.customColors.secondary,
      width: "10px",
      height: "10px",
      borderRadius: "10px",
      padding: "0",
      marginTop: "auto",
      marginBottom: "auto",
      marginRight: "10px",
    },
    mainPrchsCircle: {
      backgroundColor: theme.customColors.dark,
      width: "10px",
      height: "10px",
      borderRadius: "10px",
      padding: "0",
      marginTop: "auto",
      marginBottom: "auto",
      marginRight: "10px",
    },
    buyHeader: {
      color: theme.customColors.secondary,
      fontSize: window.innerWidth > 1300 ? "36px" : "32px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "40px",
      width: "auto",
    },
    section234: {
      position: "absolute",
      marginTop: "311px",
      width: "96%",
      zIndex: -1,
    },
    mainBtn: {
      height: "48px !important",
      backgroundColor: "transparent !important",
      border: "1px solid " + theme.customColors.childBack + " !important",
      borderRadius: "16px !important",
      "& .MuiButton-label": {
        color: theme.customColors.childBack + " !important",
      },
    },
    section2: {
      paddingLeft: "70px",
      paddingRight: "70px",
      zIndex: 99,
      position: "relative",
    },
    gridHeader: {
      color: "#1A227B",
      fontSize: window.innerWidth > 1000 ? "32px" : "18px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "0.036px",
    },
    trnsGridHeader: {
      color: theme.customColors.childBack,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "0.036px",
    },
    section3Cntnr: {
      width: "100%",
      height: "100%",
      borderRadius: "4px",
      backgroundColor: "#FFF",
      background:
        window.innerWidth > 1000
          ? `url(${process.env.PUBLIC_URL + "/images/section3-main.svg"})`
          : "",
      backgroundRepeat: "no-repeat",
      backgroundPositionY: "center",
    },
    section3: {
      zIndex: 99,
      position: "relative",
    },
    section3Hdr: {
      color: "#0A0B0D",
      fontStyle: "normal",
      fontSize: window.innerWidth > 1000 ? "24px" : "18px",
      fontWeight: 600,
    },
    secFac2Hdr: {
      color: "#0A0B0D",
      fontStyle: "normal",
      fontSize: window.innerWidth > 1000 ? "28px" : "21px",
      fontWeight: 700,
      width: "fit-content",
    },
    secFac1Hdr: {
      color: "#0A0B0D",
      fontStyle: "normal",
      fontSize: window.innerWidth > 1000 ? "32px" : "20px",
      fontWeight: 700,
      width: "fit-content",
      marginBottom: "50px",
    },
    facilitySecTxt: {
      color: "#000",
      fontSize: window.innerWidth > 1000 ? "20px" : "15px",
      backgroundColor: "rgba(255,255,255,0.5)",
      fontWeight: 400,
      lineHeight: "30px",
      textAlign: "justify",
      padding: "10px 35px",
      width: "fit-content",
    },
    section3Txt: {
      color: "#000",
      fontSize: window.innerWidth > 1000 ? "18px" : "12px",
      fontStyle: "normal",
      lineHeight: "30px",
      letterSpacing: "0.032px",
      width: "auto",
      padding: "0",
    },
    section3TxtLst: {
      color: "#000",
      fontSize: window.innerWidth > 1000 ? "18px" : "12px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "30px",
      letterSpacing: "0.032px",
      width: "auto",
      padding: "0",
    },
    section4: {
      zIndex: 99,
      position: "relative",
    },
    section4Cntnt: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      paddingBottom: "32px",
      backgroundPositionY: "center",
    },
    section4Hdr: {
      color: theme.customColors.childBack,
      fontSize: window.innerWidth > 1000 ? "24px" : "18px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "0.048px",
    },
    section4Text: {
      color: theme.customColors.childBack,
      textAlign: "justify",
      fontSize: window.innerWidth > 1000 ? "20px" : "12px",
      fontStyle: "normal",
      lineHeight: "32px",
      letterSpacing: "0.04px",
    },
    section4Btn: {
      background: "#FF4F01 !important",
      backgroundColor: "#FF4F01 !important",
      height: "39px !important",
      "& .MuiButton-label": {
        color: theme.customColors.childBack + " !important",
      },
    },
    section5Btn: {
      background: theme.customColors.dark + " !important",
      backgroundColor: theme.customColors.dark + " !important",
      height: "39px !important",
      "& .MuiButton-label": {
        color: theme.customColors.childBack + " !important",
      },
    },
    section555Btn: {
      background: theme.customColors.dark + " !important",
      backgroundColor: theme.customColors.dark + " !important",
      height: "39px !important",
      "& .MuiButton-label": {
        color: theme.customColors.childBack + " !important",
      },
    },
    section5: {
      zIndex: 99,
      position: "relative",
    },
    section5Cntnt: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPositionY: "center",
    },
    section5Hdr: {
      color: theme.customColors.childBack,
      fontSize: window.innerWidth > 1000 ? "24px" : "18px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "0.048px",
    },
    section7Hdr: {
      fontSize: window.innerWidth > 1000 ? "24px" : "18px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "0.048px",
    },
    section5Text: {
      color: theme.customColors.childBack,
      textAlign: "justify",
      fontSize: window.innerWidth > 1000 ? "20px" : "12px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "32px",
      letterSpacing: "0.04px",
    },
    section7Text: {
      textAlign: "justify",
      fontSize: window.innerWidth > 1000 ? "20px" : "12px",
      fontStyle: "normal",
      lineHeight: "32px",
      letterSpacing: "0.04px",
    },
    section567: {
      position: "absolute",
      marginTop: "210px",
      width: "96%",
      zIndex: -1,
    },
    facilitySecCntnr: {
      width: "100%",
      height: "100%",
      paddingTop: "15% !important",
    },
    section6Cntnr: {
      width: "100%",
      height: "100%",
      borderRadius: "4px",
    },
    section6: {
      zIndex: 99,
      position: "relative",
    },
    manaTec: {
      color: theme.customColors.dark,
      fontStyle: "normal",
      fontWeight: 600,
      letterSpacing: "0.064px",
      width: "auto",
      cursor: "pointer",
    },
    manaHdr: {
      color: "#0A0B0D",
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: 600,
      letterSpacing: "0.064px",
      width: "auto",
    },
    mgzn: {
      color: theme.customColors.secondary,
      "& hover": {
        boxShadow: "none !important",
      },
    },
    middleBold: {
      color: theme.customColors.dark,
      fontSize: window.innerWidth > 1000 ? "24px" : "18px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: "0.064px",
    },
    check: {
      color: theme.customColors.dark,
      width: "30px",
      height: "30px",
      padding: "0",
      marginRight: "10px",
    },
    trnsCntnr: {
      color: theme.customColors.childBack,
      zIndex: 999,
    },
    trnsRow: {
      position: "relative",
      minHeight: "580px",
      borderRadius: "8px 8px 0px 0px",
      background: theme.customColors.childBack,
      filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
      textAlign: "center",
      padding: "10px",
    },
    trnsRowSm: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      borderRadius: "8px 8px 0px 0px",
      background: theme.customColors.childBack,
      textAlign: "center",
      padding: "10px",
    },
    trnsImg: {
      maxWidth: "100%",
    },
    tag: {
      display: "block",
      marginLeft: "-20px",
      marginTop: "-20px",
      height: "30px",
    },
    tagSm: {
      display: "block",
      marginLeft: "-18px",
      height: "30px",
    },
    tagText: {
      fontSize: "20px",
      height: "100%",
      width: "100%",
      maxWidth: "120px",
      minWidth: "100px",
      textAlign: "center",
      fontWeight: 500,
      color: theme.customColors.childBack,
    },
    tagTextSm: {
      fontSize: "12px",
      height: "100%",
      width: "100%",
      textAlign: "center",
      fontWeight: 500,
      color: theme.customColors.childBack,
    },
    trnsHdr: {
      minWidth: "80px",
      color: "#000",
      textAlign: "center",
      fontSize: "15px",
      fontStyle: "normal",
      fontWeight: 600,
    },
    trnsHdrSm: {
      minWidth: "80px",
      color: "#000",
      textAlign: "center",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 600,
    },
    trnsDevider: {
      width: "100%",
      height: "1px",
      background: "#989898",
    },
    trnsDescription: {
      color: "#000",
      textAlign: "left",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      paddingRight: "10px",
      paddingLeft: "10px",
    },
    trnsDescriptionSm: {
      color: "#000",
      textAlign: "left",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      paddingRight: "10px",
      paddingLeft: "10px",
      lineHeight: "20px",
    },
    trnsAmount: {
      color: "#000",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
    },
    pageArrow: {
      cursor: "pointer",
      width: "40px !important",
      display: "table-cell",
      verticalAlign: "middle",
    },
    disablePageArrow: {
      color: "#100f0f",
      pointerEvents: "none",
      opacity: "1",
      width: "40px !important",
      display: "table-cell",
      verticalAlign: "middle",
    },
    arrowCntnr: {
      width: "auto",
      marginTop: "auto",
      marginBottom: "auto",
      zIndex: 999,
    },
    showAd: {
      fontSize: "24px",
      color: theme.customColors.touch,
      width: "auto",
      fontWeight: 700,
      cursor: "pointer",
    },
    "@keyframes myEffect1": {
      "0%": {
        transform: "translateX(0)",
      },
      "20%": {
        transform: "translateX(-2px)",
      },
      "40%": {
        transform: "translateX(2px)",
      },
      "60%": {
        transform: "translateX(-2px)",
      },
      "80%": {
        transform: "translateX(2px)",
      },
      "100%": {
        transform: "translateX(0)",
      },
    },
    "@keyframes myEffect2": {
      "0%": {
        transform: "translateX(0)",
      },
      "20%": {
        transform: "translateX(2px)",
      },
      "40%": {
        transform: "translateX(-2px)",
      },
      "60%": {
        transform: "translateX(2px)",
      },
      "80%": {
        transform: "translateX(-2px)",
      },
      "100%": {
        transform: "translateX(0)",
      },
    },
    gudCntnr: {
      width: "100%",
      height: "56px",
      flexShrink: 0,
      borderRadius: "42px",
      border: "1.5px solid #FFF",
      boxShadow: "0px 1px 2.8px 1px rgba(0, 0, 0, 0.58)",
      cursor: "pointer",
    },
    mainImg: {
      background:
        window.innerWidth > 700
          ? `url(${process.env.PUBLIC_URL + "/images/section1-main.svg"})`
          : "white",
      width: "100%",
      margin: "0",
      padding: "0",
    },
    trnsTxt: {
      width: "auto",
      cursor: "pointer",
      fontWeight: 700,
    },
    pgntn: {
      zIndex: 99,
      display: "flex",
      justifyContent: "center",
      "& ul": {
        display: "flex",
      },
      "& li": {
        height: "40px",
        textAlign: "center",
        width: "40px",
        backgroundColor: "transparent !important",
        color: "white",
        marginRight: "4px",
        marginLeft: "4px",
        display: "inline-table",
        border: "none !important",
        "& .border": {
          border: "none !important",
        },
        "& button": {
          display: "contents",
          marginTop: "-10px",
          backgroundColor: "transparent !important",
          color: "white",
        },
        "& aria-current='page'": {
          color: "red",
        },
      },

      "& [aria-current='page']": {
        backgroundColor: "#d0d0d0 !important",
        borderRadius: "8px",
        "& button": {
          color: "black",
        },
      },
    },
    enNmbr: {
      fontFamily: "Regular !important",
    },
    trnsRoot: {
      overflowX: "scroll",
      "&::-webkit-scrollbar": {
        height: "0.4em",
      },
      "&::-webkit-scrollbar:hover": {
        height: "0.4em",
        display: "block !important",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px white",
        backgroundColor: "#0A2FB1",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#0A2FB1",
      },
    },
    transitionLtoR: {
      position: "relative",
      alignItems: "center",
      display: "flex",
      zIndex: 500,
      gap: "20px",
      transition: "position 0.7s, left 0.7s",
    },
    slct: {
      width: "100% !important",
      borderRadius: "0 !important",
      borderRight: "1px solid white !important",
      "& .MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          backgroundColor: "transparent !important",
        },
      "& .MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          "&, &:before": {
            borderRadius: "0px !important",
          },
        },
      "& .MuiInputBase-root": {
        border: "none !important",
        borderRadius: "0 !important",
        height: "80px",
      },
      "& input": {
        fontSize: 14,
        "&::placeholder": {
          color: "black !important",
          fontWeight: 900,
          fontSize: 14,
          opacity: 1,
        },
      },
    },
    slct1: {
      width: "100% !important",
      borderRadius: "0 !important",
      borderRight: "1px solid white !important",
      "& .MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          backgroundColor: "transparent !important",
          "&, &:before": {
            borderBottom: "none !important",
          },
        },
      "& .MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          "&, &:before": {
            borderRadius: "0px !important",
          },
        },
      "& .MuiInputBase-root": {
        border: "none !important",
        borderRadius: "0 !important",
        height: "80px",
      },
      "& input": {
        fontSize: 14,
        "&::placeholder": {
          color: "black !important",
          fontSize: 14,
          fontWeight: 900,
          opacity: 1,
        },
      },
    },
    slct1Last: {
      width: "100% !important",
      borderRadius: "0 !important",
      "& .MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          backgroundColor: "transparent !important",
          "&, &:before": {
            borderBottom: "none !important",
          },
        },
      "& .MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          "&, &:before": {
            borderRadius: "0px !important",
          },
        },
      "& .MuiInputBase-root": {
        border: "none !important",
        borderRadius: "0 !important",
        height: "80px",
      },
      "& input": {
        fontSize: 14,
        "&::placeholder": {
          color: "black !important",
          fontSize: 14,
          fontWeight: 900,
          opacity: 1,
        },
      },
    },
    slctLast: {
      width: "100% !important",
      borderRadius: "0 !important",
      "& .MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          backgroundColor: "transparent !important",
        },
      "& .MuiFilledInput-underline.MuiInputBase-root.MuiInputBase-colorPrimary":
        {
          "&, &:before": {
            borderRadius: "0px !important",
          },
        },
      "& .MuiInputBase-root": {
        border: "none !important",
        borderRadius: "0 !important",
        height: "80px",
      },
      "& input": {
        fontSize: 14,
        "&::placeholder": {
          color: "black !important",
          fontSize: 14,
          fontWeight: 900,
          opacity: 1,
        },
      },
    },
    autoSlct: {
      width: "33%",
      padding: "0",
    },
    iphoneBg: {
      maxWidth: "max-content",
      width: "100%",
      // marginTop: "20px",
      // marginLeft: "20px",
      padding: "20px",
      display: "flex",
      overflow: "hidden",
      "& img": {
        display: "block",
        transition: ".3s ease-in-out",
      },
      "&:hover img": {
        transform: "scale(1.01)",
      },
    },
    iphoneFrame: {
      maxWidth: "max-content",
      border: "1px solid #A6A6A6",
      // width: "316px",
      height: "381px",
    },
    addBg: {
      maxWidth: "max-content",
      marginTop: "20px",
      marginLeft: "20px",
      display: "inline-block",
      overflow: "hidden",
      "& img": {
        display: "block",
        transition: ".3s ease-in-out",
      },
      "&:hover img": {
        transform: "scale(1.3)",
      },
    },
    addFrame: {
      maxWidth: "max-content",
      border: "1px solid #A6A6A6",
      height: "334px",
    },
    hndBg: {
      maxWidth: "max-content",
      display: "flex",
      padding: "20px",
      overflow: "hidden",
      "& img": {
        display: "block",
        transition: ".3s ease-in-out",
      },
      "&:hover img": {
        transform: "scale(1.3)",
      },
    },
    hndFrame: {
      maxWidth: "max-content",
      border: "1px solid #A6A6A6",
      width: "350px",
      height: "527px",
      padding: "0",
    },
    btnFix: {
      textAlign: "center",
      border: "1px solid",
      borderRadius: "5px",
      marginTop: "20px",
    },
    img: {
      display: "inline-block",
      overflow: "hidden",
      "& img": {
        display: "block",
        transition: ".3s ease-in-out",
      },
      "&:hover img": {
        transform: "scale(1.04)",
      },
    },
    ad: {
      padding: "0px 20px",
      border: "1px solid " + theme.customColors.childBack,
      borderRadius: "22px",
      display: "table",
      textAlign: "center",
      width: "250px",
      cursor: "pointer",
      fontSize: "16px",
      backgroundColor: "#00000096",
      "&:hover": {
        backgroundColor: theme.customColors.dark,
        border: "1px solid " + theme.customColors.dark,
      },
    },
    shadowText: {
      width: "auto",
    },
    video: {
      "& video": {
        maxHeight: "98vh",
      },
    },
    secOneCntnr: {
      backgroundColor: "black",
      overflow: "hidden",
      top: "-120px",
      position: "relative",
      width: "100%",
    },
    secOne: {
      direction: "ltr",
      backgroundColor: "transparent !important",
      top: "0",
      overflowX: "hidden",
      position: "relative",
      "&::-webkit-scrollbar": {
        width: "0",
        height: "0 !important",
        "&:hover": {
          width: "0",
          height: "0",
          display: "none !important",
          marginTop: "300px",
          marginBottom: "300px",
        },
      },
    },
    pelakHeader: {
      fontSize: "32px",
      fontWeight: 700,
      lineHeight: "40px",
    },
    pelakSec: {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "40px",
    },
    pelakGrid: {
      display: "flex",
      justifyContent: "center",
      textAlign: "justify",
      padding: "0 40px 0 100px !important",
    },
    btnFixDiv: {
      padding: "0",
    },
    carModelTitle: {
      fontFamily: "PeydaLight !important",
    },
    dmTo: {
      paddingLeft: "50px",
    },
    facSecBtn: {
      background: "#fff !important",
      backgroundColor: "#fff !important",
      height: "39px !important",
      "& .MuiButton-label": {
        color: "#000" + " !important",
      },
      border: "1px solid #000 !important",
    },
    gridFacSec: {
      padding: "0",
    },
    gridFac: {
      padding: "0",
    },
    "@media (max-width: 1600px)": {
      gridFacSec: {
        width: "150px",
      },
      gridFac: {
        display: "flex",
        justifyContent: "center",
        paddingBottom: "5px",
      },
      facSecBtn: {
        width: "150px",
      },
    },
    "@media (max-width: 768px)": {
      secFac2Hdr: {
        marginLeft: "182px",
        textAlign: "center",
        width: "auto",
      },
      facilitySecTxt: {
        marginLeft: "87px",
        textAlign: "center",
        padding: "0",
        width: "auto",
      },
      secFac1Hdr: {
        textAlign: "center",
        margin: "-25px 0",
      },
      facilitySecCntnr: {
        paddingTop: "1% !important",
      },
      btnFixDiv: {
        paddingRight: "34px",
      },
      addFrame: {
        marginTop: "20PX",
        height: "216px",
      },
      pelakHeader: {
        fontSize: "18px",
        fontWeight: 700,
      },
      pelakSec: {
        fontSize: "13px",
      },
      pelakGrid: {
        padding: "30px !important",
      },
      secOneCntnr: {
        top: "-12px",
      },
    },
  })
);
